import { Component } from '@angular/core';

import { EventPage } from '../event/event';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = EventPage;
  tab3Root = ContactPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts